import React from 'react';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

// What changes when you move from a service company to a product company
const rows = [
  { label: 'Your work', from: 'Maintain client code', to: 'Build and own features' },
  { label: 'Interviews', from: 'Aptitude + HR', to: 'DSA + machine coding' },
  { label: 'Growth', from: 'Fixed yearly bands', to: 'Based on impact' },
  { label: 'Salary', from: '₹4–8 LPA', to: '₹20–30 LPA', highlight: true }
];

const skills = ['DSA', 'Machine Coding', 'Real Projects'];

const HeroSwitchCard = () => (
  <div className="switch-card">
    <span className="hero-card-pill">
      <SwapHorizIcon sx={{ fontSize: 16 }} />
      Make the switch to product-based
    </span>

    <div className="switch-toggle">
      <span className="switch-toggle-label">Service</span>
      <span className="switch-toggle-track"><span className="switch-toggle-knob" /></span>
      <span className="switch-toggle-label switch-toggle-label--on">Product</span>
    </div>

    <div className="switch-table">
      {rows.map((r, i) => (
        <div className={`switch-row ${r.highlight ? 'is-highlight' : ''}`} key={r.label} style={{ '--i': i }}>
          <span className="switch-row-label">{r.label}</span>
          <span className="switch-row-from">{r.from}</span>
          <span className="switch-row-arrow">→</span>
          <span className="switch-row-to">{r.to}</span>
        </div>
      ))}
    </div>

    <div className="hero-card-skills">
      <span>What gets you through</span>
      <ul>
        {skills.map((s, i) => <li key={s} style={{ '--i': i }}>{s}</li>)}
      </ul>
    </div>
  </div>
);

export default HeroSwitchCard;
